import React from "react"
import { Box } from "@infotech/uikit-grid"
import { CleanButton } from "@infotech/uikit-button"
import { NoIcon } from "@infotech/uikit-icons"
import styles from "./styles.css"

export default ({
  title,
  headerBackgroundColor,
  onClose,
  children,
  footer,
  loose,
  contentProps,
  footerJustify,
  noStyle, // Custom prop, was not in uikit
  ...restProps
}) => (
  <Box
    flex
    column
    className={noStyle ? null : styles.ModalWindow}
    dev-name="Modal window"
    {...restProps}
  >
    <Box
      w={1}
      flex
      justify="flex-start"
      align="center"
      style={{
        borderBottom: `1px solid rgba(0, 0, 0, .06)`,
        boxSizing: `border-box`,
        padding: `0 16px`,
        backgroundColor: headerBackgroundColor,
        borderTopLeftRadius: `2px`,
        borderTopRightRadius: `2px`,
      }}
    >
      <Box
        flex
        align="center"
        style={{
          fontWeight: 600,
          fontFamily: `"Source Sans Pro", sans-serif`,
        }}
      >
        {title}
      </Box>
      <Box flex align="center" justify="flex-end" ml="auto" loose>
        {onClose && <CleanButton onClick={onClose} icon={NoIcon} />}
      </Box>
    </Box>
    <Box
      flex
      column
      w={1}
      p={loose ? 0 : `2md`}
      style={{
        boxSizing: `border-box`,
        padding: `8px 0`,
      }}
      {...contentProps}
    >
      {children}
    </Box>
    <Box
      w={1}
      flex
      px="2md"
      style={{
        borderTop: `1px solid rgba(0, 0, 0, .06)`,
        justifyContent: footerJustify || `flex-start`,
        boxSizing: `border-box`,
        padding: `8px 16px`,
      }}
    >
      {footer}
    </Box>
  </Box>
)
